import React, { useState } from 'react';
import usePagination from './usePagination';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SelectPagination from './SelectPagination';

const Pagination = ({ totalPages, withLimit = false }) => {
  const { updatePageUrl, page, limit } = usePagination();
  const [inputPage, setInputPage] = useState(String(page));
  const [selectLimit, setSelectLimit] = useState(String(limit));

  const handlePageChange = () => {
    const newPage = parseInt(inputPage);
    if (isNaN(newPage)) {
      setInputPage(String(page));
      return;
    }
    const clampedPage = Math.max(1, Math.min(totalPages, newPage));
    if (clampedPage !== page) {
      updatePageUrl(clampedPage, limit);
    }
    setInputPage(String(clampedPage));
  };

  const handleLimitChange = (limit) => {
    setSelectLimit(limit);
    updatePageUrl(1, limit);
  };

  return (
    <div className="relative flex flex-row  flex-wrap justify-center gap-2 mt-4">
      <div className="flex flex-row items-center justify-center gap-2 flex-1 text-gray-700">
        <button
          className="cursor-pointer flex items-center justify-center border border-primary-300 text-primary-300 rounded disabled:text-gray-400 disabled:border-gray-400 hover:border-primary-500"
          disabled={page <= 1}
          onClick={() => updatePageUrl(page - 1)}>
          <KeyboardArrowLeft />
        </button>
        <input
          type="number"
          value={inputPage}
          onChange={(e) => setInputPage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handlePageChange();
          }}
          onBlur={handlePageChange}
          className="w-12 text-center border border-primary-300 rounded px-1 active:border-primary-500 outline-none"
          min={1}
          max={totalPages}
        />
        <span className={'whitespace-nowrap'}>из {totalPages}</span>
        <button
          className="cursor-pointer flex items-center justify-center border border-primary-300 text-primary-300 rounded disabled:text-gray-400 disabled:border-gray-400 hover:border-primary-500"
          disabled={page >= totalPages}
          onClick={() => updatePageUrl(page + 1)}>
          <KeyboardArrowRight />
        </button>
      </div>
      {withLimit ? <SelectPagination limit={selectLimit} onLimitChange={handleLimitChange} /> : null}
    </div>
  );
};
export default Pagination;
